<template>
    <div>
        <div class="order-userInfo">
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group">
                        <el-row>
                            <el-col :span="8" class="order-item">学校域名：<span>{{ product.content.basic_configure.cor_domain_url}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item order-logo-fix"><em>Logo：</em><span
                                    v-if="product.content.basic_configure.fileList && product.content.basic_configure.fileList.length == 0">暂无</span><span
                                    v-else v-for="logo in product.content.basic_configure.fileList" :key="logo.uid"><img
                                    :src="logo.url"/></span>
                            </el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>额度设置</h5>
                    <div class="userInfo-group">
                        <div class="set-wrapper">
                            <el-row class="set-number">
                                <div class="order-item" style="float:left; width:100px; margin-right:30px;">日额度设置</div>
                                <el-row>
                                    <el-col :span="5" class="order-item">
                                        总：{{product.content.limit_configure.day.all}}
                                        <span v-if='oldConfig && typeof oldConfig.limit_configure != "undefined" && product.content.limit_configure.day.all != oldConfig.limit_configure.day.all ' style="color: #f5222d">原来:{{oldConfig.limit_configure.day.all}}</span>
                                    </el-col>
                                </el-row>
                            </el-row>
                        </div>
                        <div>
                            <el-table
                                    :data="product.content.limit_configure.batch"
                                    border
                                    style="width: 100%;">
                                <el-table-column prop="subject_name" label="科目">
                                </el-table-column>
                                <el-table-column label="小学">
                                    <el-table-column prop="config.primary.pu" label="普">
                                        <template slot-scope="scope">
                                            {{scope.row.config.primary.pu}}
                                            <span v-html="showOldConfig('primary',scope.row.subject_id,'pu')"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="config.primary.jing" label="精">
                                        <template slot-scope="scope">
                                            {{scope.row.config.primary.jing}}
                                            <span v-html="showOldConfig('primary',scope.row.subject_id,'jing')"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="config.primary.te" label="特">
                                        <template slot-scope="scope">
                                            {{scope.row.config.primary.te}}
                                            <span v-html="showOldConfig('primary',scope.row.subject_id,'te')"></span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="初中">
                                    <el-table-column prop="config.middle.pu" label="普">
                                        <template slot-scope="scope">
                                            {{scope.row.config.middle.te}}
                                            <span v-html="showOldConfig('middle',scope.row.subject_id,'pu')"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="config.middle.jing" label="精">
                                        <template slot-scope="scope">
                                            {{scope.row.config.middle.jing}}
                                            <span v-html="showOldConfig('middle',scope.row.subject_id,'jing')"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="config.middle.te" label="特">
                                        <template slot-scope="scope">
                                            {{scope.row.config.middle.te}}
                                            <span v-html="showOldConfig('middle',scope.row.subject_id,'te')"></span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="高中">
                                    <el-table-column prop="config.high.pu" label="普">
                                        <template slot-scope="scope">
                                            {{scope.row.config.high.pu}}
                                            <span v-html="showOldConfig('high',scope.row.subject_id,'pu')"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="config.high.jing" label="精">
                                        <template slot-scope="scope">
                                            {{scope.row.config.high.jing}}
                                            <span v-html="showOldConfig('high',scope.row.subject_id,'jing')"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="config.high.te" label="特">
                                        <template slot-scope="scope">
                                            {{scope.row.config.high.te}}
                                            <span v-html="showOldConfig('high',scope.row.subject_id,'te')"></span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>版本绑定</h5>
                    <div>
                        <el-table
                                :data="product.content.version_bind"
                                border
                                style="width: 97%; margin:0 20px;">
                            <el-table-column
                                    prop="subject"
                                    label="学科"
                                    width="100px">
                            </el-table-column>
                            <el-table-column label="绑定版本">
                                <template slot-scope="scope">
                                    <!-- 对应版本 -->
                                    <div v-if="scope.row.version && scope.row.version.length == 0">---</div>
                                    <div v-else v-for="(versionBind,index) in scope.row.version" :key="index"
                                         class="version-gap">
                                        {{versionBind.stage_name}}：<span
                                            v-for="(name,index) in versionBind.version_bind_name"
                                            :key="index">{{name}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>应用绑定</h5>
                    <div>
                        <el-table
                                :data="product.content.app_bind">
                            <el-table-column
                                    prop="app_name"
                                    label="应用名称">
                            </el-table-column>
                            <el-table-column
                                    label="推荐">
                                <template slot-scope="scope">
                                    <span>{{scope.row.is_recommend ? "是" : "否"}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>最大空间设置</h5>
                    <div class="userInfo-group">
                        <el-row>
                            <el-col class="order-item" :span="24">
                                最大空间设置：<span>{{product.content.max_setting}}G</span>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomerService from "~/services/customer";
    export default {
        props: {
            product: {
                type: Object
            }
        },
        data() {
            return {
                configUsed: false,
                oldConfig:''
            }
        },
        created(){
          this.getOrder();
        },
        methods: {
            getOrder() {
                CustomerService.product_config({product_code:this.product.product_code,customer_id:this.product.customer_id}).then(res => {
                    this.oldConfig = res.data;
                })
            },
            showOldConfig(stage,subject_id,type){
                if(this.oldConfig && typeof this.oldConfig.limit_configure !="undefined"){
                    let item = this.oldConfig.limit_configure.batch.find(i=>{return i.subject_id == subject_id });
                    let oldItem = this.product.content.limit_configure.batch.find(i=>{return i.subject_id == subject_id });
                    if(!item)  return "";
                    if(oldItem.config[stage][type] == item.config[stage][type]) return "";
                    return "<span  style='color: #f5222d'>原来:"+item.config[stage][type]+"</span>";
                }
                return "";
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/products/jiaoben3.vue